<template>
  <div class="prompt-message">
    <gj-alert type="info" show-icon>
      <template #title>
          更新时间：{{ updateTime }}（更新提醒：每天早上9点更新，可能有稍微延迟、更新之前处于无数据状态，如过久未更新，请点击同步按钮进行更新）
      </template>
    </gj-alert>
  </div>
</template>
  
<script>
export default {
  props: {
    updateTime: {
      default: ""
    }
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.prompt-message {
  background: #fff;
  padding-bottom: 12px;
  /deep/.el-alert--info {
    background-color: #EDF7FF;
    color: #333;
    font-size: 14px;
  }
}
</style>